<template>
  <footer class="footer has-cards">
    <ArgonContactForm />

    <div class="container">
      <div class="row row-grid align-items-center my-md">
        <div class="col-lg-6">
          <h3 class="text-info font-weight-light mb-2">Thank you for visiting us!</h3>
          <h4 class="mb-0 text-white font-weight-light">Let's get in touch.</h4>
        </div>
        <div class="col-lg-6 text-lg-center btn-wrapper">
          <!-- AddThis -->
          <div class="addthis_inline_share_toolbox"></div>
        </div>
      </div>
      <hr class="footer-hr">
      <div class="row align-items-center justify-content-md-between">
        <div class="col-md-12 text-center">
          <div class="copyright text-white">
            &copy; 2019
            <span class="text-info">AuspiDev</span>.
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import ArgonContactForm from "@/components/ArgonContactForm.vue";

export default {
    name: "ArgonFooter",
    components: {
      ArgonContactForm
    }
};
</script>
